import { Modal } from "bootstrap";
import React, {
    forwardRef,
    useImperativeHandle,
    useRef,
    useEffect,
    useState,
} from "react";

import Select from "react-select";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

// import * as b2cleadService from "../../Services/b2cleadService";
import * as b2bleadService from "../../Services/b2bleadService";
import { toast } from "react-toastify";

const B2BActivityQuationsModal = forwardRef(
    ({ leadDetails, getLeadData, getLeadFollowup }, ref) => {

        const modalRef = useRef(null);
        const bsModal = useRef(null);

        const navigate = useNavigate();

        const [plans, setPlans] = useState([]);
        const [customPlans, setCustomPlans] = useState([]);

        const [isPlanEnabled, setIsPlanEnabled] = useState(true);
        const [isCustomPlanEnabled, setIsCustomPlanEnabled] = useState(true);
        const [isSubmitting, setIsSubmitting] = useState(false);

        const {
            register,
            handleSubmit,
            reset,
            watch,
        } = useForm({
            mode: "onSubmit",

            defaultValues: {

                consumerName: "",

                consumerEmail: "",

                consumerPhone: "",

            },
        });

        const plan = watch("plan");
        const customPlan = watch("customePlanId");

        // ================= MODAL TOGGLE =================
        useImperativeHandle(ref, () => ({
            toggle() {
                if (!bsModal.current) {
                    bsModal.current = new Modal(modalRef.current);
                }
                bsModal.current.show();
            },
            close() {
                bsModal.current?.hide();
            },
        }));

        // ================= FETCH =================
        useEffect(() => {
            b2bleadService.getPlans()
                .then(res => setPlans(res?.data?.data || []))
                .catch(err => console.log(err));

            b2bleadService.getCustomPlans()
                .then(res => setCustomPlans(res?.data?.data || []))
                .catch(err => console.log(err));
        }, []);


        useEffect(() => {
            if (plan) {
                setIsPlanEnabled(true);
                setIsCustomPlanEnabled(false);
            } else if (customPlan) {
                setIsPlanEnabled(false);
                setIsCustomPlanEnabled(true);
            } else {
                setIsPlanEnabled(true);
                setIsCustomPlanEnabled(true);
            }
        }, [plan, customPlan]);

        useEffect(() => {

            reset({

                consumerName:
                    leadDetails?.primaryContactName || "",

                consumerEmail:
                    leadDetails?.emailId || "",

                consumerPhone:
                    leadDetails?.mobileNumber || "",

            });

        }, [leadDetails, reset]);

        const onSubmit = async (data) => {

            try {
                setIsSubmitting(true);

                const formData = new FormData();

                // COMMON FIELDS
                formData.append(
                    "consumerName",
                    data.consumerName || ""
                );

                formData.append(
                    "consumerEmail",
                    data.consumerEmail || ""
                );

                formData.append(
                    "consumerPhone",
                    data.consumerPhone || ""
                );

                // MAIN PLAN
                if (data.plan) {

                    formData.append(
                        "plan",
                        data.plan
                    );

                    formData.append(
                        "planType",
                        "m"
                    );

                }

                // CUSTOM PLAN
                if (data.customePlanId) {

                    formData.append(
                        "customePlanId",
                        data.customePlanId
                    );

                    formData.append(
                        "planType",
                        "c"
                    );

                }

                const res =
                    await b2bleadService.addQuotation(
                        leadDetails?.id,
                        formData
                    );

                if (
                    res?.data?.status === "success" ||
                    res?.data?.status === "succsess"
                ) {

                    toast.success(
                        res?.data?.message ||
                        "Quotation added successfully"
                    );

                    getLeadData?.();

                    getLeadFollowup?.();

                    reset();

                    bsModal.current?.hide();

                } else {

                    toast.error(
                        res?.data?.message ||
                        "Failed to add quotation"
                    );

                }

            } catch (err) {

                toast.error(
                    err?.response?.data?.message ||
                    "Something went wrong"
                );

            } finally {

                setIsSubmitting(false);
            }

        };
        return (
            <div
                className="modal"
                ref={modalRef}
                tabIndex="-1"
                aria-hidden="true"
                style={{
                    background: "rgba(15,23,42,0.55)",
                    backdropFilter: "blur(5px)",
                }}
            >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content border-0 rounded-4">

                        {/* HEADER (UNCHANGED UI) */}
                        <div
                            className="modal-header border-0 text-white"
                            style={{
                                background:
                                    "linear-gradient(135deg,#2563eb,#1d4ed8)",
                            }}
                        >
                            <div>
                                <p className="mb-0 small opacity-75">
                                    Quotation
                                </p>
                            </div>

                            <button
                                type="button"
                                className="btn btn-light rounded-circle position-absolute"
                                style={{
                                    top: "10px",
                                    right: "18px",
                                    width: "38px",
                                    height: "38px",
                                }}
                                onClick={() => bsModal.current?.hide()}
                            >
                                <i className="fa fa-times"></i>
                            </button>
                        </div>

                        {/* BODY */}
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="modal-body">
                                <div className="row g-3">

                                    {/* POC NAME */}
                                    <div className="col-md-6">
                                        <label>POC Name</label>
                                        <input
                                            className="form-control"
                                            {...register("consumerName")}
                                        />
                                    </div>

                                    {/* EMAIL */}
                                    <div className="col-md-6">
                                        <label>Email</label>
                                        <input
                                            className="form-control"
                                            {...register("consumerEmail")}
                                        />
                                    </div>

                                    {/* PLAN */}
                                    <div className="col-md-6">
                                        <label>Plan</label>
                                        <select
                                            className="form-select"
                                            disabled={!isPlanEnabled}
                                            {...register("plan")}
                                        >
                                            <option value="">
                                                Select plan
                                            </option>
                                            {plans.map((p) => (
                                                <option key={p.planId} value={p.planId}>
                                                    {p.planName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* CUSTOM PLAN */}
                                    <div className="col-md-6">

                                        <label>Custom Plan</label>

                                        <select
                                            className="form-select"
                                            disabled={!isCustomPlanEnabled}
                                            {...register("customePlanId")}
                                        >
                                            <option value="">
                                                Select plan
                                            </option>
                                            {customPlans.map((p) => (
                                                <option key={p.id} value={p.id}>
                                                    {p.planName}
                                                </option>
                                            ))}
                                        </select>



                                    </div>

                                    {/* PHONE */}
                                    <div className="col-md-6">
                                        <label>Phone</label>
                                        <input
                                            className="form-control"
                                            {...register("consumerPhone")}
                                        />
                                    </div>

                                    {/* <div className="col-md-6">
                                        
                                          <button
                                            type="button"
                                            className="btn btn-outline-primary btn-sm rounded-pill mt-2 fw-semibold "
                                            onClick={() => navigate("/plans")}
                                        >
                                            + Create Custom Plan
                                        </button>


                                    </div> */}

                                </div>
                            </div>

                            {/* FOOTER (UNCHANGED UI STYLE) */}
                            <div className="modal-footer border-0 px-4 pb-4">
                                <button
                                    type="button"
                                    className="btn btn-sm btn-light border rounded-pill px-4 fw-semibold"
                                    onClick={() => bsModal.current?.hide()}
                                >
                                    Close
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-sm btn-primary rounded-pill px-4 fw-semibold shadow-sm"
                                    onClick={() => {

                                        bsModal.current?.hide();

                                        navigate("/plans");

                                    }}
                                >
                                    Create Custom Plan
                                </button>

                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className="btn btn-sm btn-primary rounded-pill px-4 fw-semibold shadow-sm"
                                >
                                    {isSubmitting ? (
                                        <>
                                            <span
                                                className="spinner-border spinner-border-sm me-2"
                                                role="status"
                                                aria-hidden="true"
                                            />
                                            Saving...
                                        </>
                                    ) : (
                                        "Save Quotation"
                                    )}
                                </button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        );
    }
);

export default B2BActivityQuationsModal;